import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=608c5a4c"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=608c5a4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports